var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 475,
    viewBox: "0 0 752 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.855 0V63.7734L751.764 63.7734L751.764 65.7734H672.855V178.927H751.764L751.764 180.927H672.855V294.081H751.764L751.764 296.081H672.855V409.234H751.764L751.764 411.234H672.855V475.008H670.855V411.234H554.469V475.008H552.469V411.234H436.078V475.008H434.078V411.234L317.691 411.234V475.008H315.691V411.234H200.047V475.008H198.047V411.234H81.6562V475.008H79.6562V411.234H0V409.234H79.6562V296.081H0V294.081H79.6562V180.927H0V178.927H79.6562V65.7734H0V63.7734L79.6562 63.7734V0H81.6562V63.7734L198.047 63.7734V0H200.047V63.7734L315.691 63.7734V0H317.691V63.7734H434.078V0H436.078V63.7734L552.469 63.7734V0H554.469V63.7734L670.855 63.7734V0H672.855ZM81.6562 409.234V296.081H198.047V409.234H81.6562ZM200.047 409.234V296.081H315.691V409.234H200.047ZM317.691 409.234V296.081L434.078 296.081V409.234L317.691 409.234ZM436.078 409.234V296.081H552.469V409.234H436.078ZM554.469 409.234V296.081H670.855V409.234H554.469ZM670.855 294.081V180.927L554.469 180.927V294.081H670.855ZM670.855 178.927L554.469 178.927V65.7734L670.855 65.7734V178.927ZM552.469 294.081V180.927H436.078V294.081H552.469ZM552.469 178.927H436.078V65.7734H552.469V178.927ZM434.078 294.081V180.927H317.691V294.081L434.078 294.081ZM434.078 178.927H317.691V65.7734L434.078 65.7734V178.927ZM315.691 294.081V180.927H200.047V294.081H315.691ZM315.691 178.927H200.047V65.7734H315.691V178.927ZM198.047 294.081V180.927L81.6562 180.927V294.081H198.047ZM198.047 178.927L81.6562 178.927V65.7734L198.047 65.7734V178.927Z",
    fill: "url(#paint0_linear_3208_5390)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3208_5390",
    x1: 822.797,
    y1: -80.6075,
    x2: -53.1295,
    y2: 571.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374C72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982207,
    stopColor: "#1B2435",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionLeft);
export default __webpack_public_path__ + "static/media/Union_left.9d13124b0dec63312259f0d787c2a201.svg";
export { ForwardRef as ReactComponent };